"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "m8 6.83-4 4V18h3v-3h2v3h3v-7.17zM9 13H7v-2h2z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m8 4-6 6v10h12V10zm4 14H9v-3H7v3H4v-7.17l4-4 4 4zm-3-5H7v-2h2zm9 7V8.35L13.65 4h-2.83L16 9.18V20zm4 0V6.69L19.31 4h-2.83L20 7.52V20z"
}, "1")], 'HolidayVillageTwoTone');